import { useUnviewedCoins } from '@/hooks/useAchievements'

/** The unviewed count beside Achievements (badge spec §6): it goes up as each
 *  unlock is dismissed and clears when Achievements is opened. */
export function CoinCount() {
  const n = useUnviewedCoins().length
  if (!n) return null
  return <span className="coin-count" aria-label={`${n} new ${n === 1 ? 'coin' : 'coins'}`}>{n}</span>
}
